import React from 'react';

import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
} from '@gogame/components';
import { NumberValueFormatter } from '@gogame/intl-ts';

const Agencies = ({ data }) => {
  return data?.length ? (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell col={'name'}>Name</TableCell>
            <TableCell col={'price'} align={'right'}>
              Price
            </TableCell>
            <TableCell col={'price-with-fees'} align={'right'}>
              Price With Fees
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ name, price, priceWithFee }, i) => (
            <TableRow key={i}>
              <TableCell col={'name'}>{name}</TableCell>
              <TableCell col={`price`} align={'right'}>
                <NumberValueFormatter.Currency value={price} />
              </TableCell>
              <TableCell col={`price-with-fees`} align={'right'}>
                <NumberValueFormatter.Currency value={priceWithFee} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Typography color={'textSecondary'}>No Agencies</Typography>
  );
};

export default Agencies;
